import { Entity } from './entities.model';
import { RelationStatus } from './relations.model';
import { TableOptions } from './table-patterns';
import { Stadium } from './stadium.model';
// tslint:disable: variable-name

export class Club extends Entity {
  initials?: string;
  primary_phone?: string;
  board_ceo?: string;
  board_vice_president?: string;
  board_finance?: string;
  board_base_director?: string;
  board_sport_director?: string;
  legal_name?: string;
  legal_email?: string;
  legal_phone?: string;
  stadium_id?: number;
  stadiums?: Stadium[];

  constructor(o?: Partial<Club>, normalize: TableOptions = { int: [] }) {
    normalize.int.push(...['stadium']);
    super(o, normalize);
  }
}

export class ClubRelation extends Club {
  relation_id: number;
  parent_id: number;
  child_id: number;
  requester_id: number;
  status: RelationStatus;

  constructor(o: Partial<ClubRelation>) {
    super(o, { int: ['relation_id', 'parent_id', 'child_id', 'requester_id'] });
  }

  public static getStatusName(status: RelationStatus) {
    const s = {
      P: 'Pendente',
      A: 'Aceito',
      R: 'Rejeitado',
      C: 'Cancelado',
      T: 'Terminado'
    };
    return s[status];
  }

  public static getActionName(status: RelationStatus) {
    const s = {
      A: 'Aceitanto',
      R: 'Rejeitando',
      C: 'Cancelando',
      T: 'Terminando'
    };
    return s[status];
  }
}
